import styles from './StandingsTableSkeleton.module.css'

const SKELETON_ROWS = 8

export function StandingsTableSkeleton() {
  return (
    <div className={styles.wrapper}>
      {/* GW navigator placeholder */}
      <div className={styles.navigatorPlaceholder}>
        <div className={styles.shimmer} style={{ width: 32, height: 30, borderRadius: 4 }} />
        <div className={styles.shimmer} style={{ width: 110, height: 18, borderRadius: 4 }} />
        <div className={styles.shimmer} style={{ width: 32, height: 30, borderRadius: 4 }} />
      </div>

      {/* Table skeleton */}
      <table className={styles.table}>
        <thead>
          <tr className={styles.headRow}>
            <th className={styles.colRank}>
              <div className={styles.shimmer} style={{ width: 16, height: 11 }} />
            </th>
            <th className={styles.colTeam}>
              <div className={styles.shimmer} style={{ width: 48, height: 11 }} />
            </th>
            <th className={styles.colNum}>
              <div className={styles.shimmer} style={{ width: 16, height: 11, marginLeft: 'auto' }} />
            </th>
            <th className={styles.colNum}>
              <div className={styles.shimmer} style={{ width: 32, height: 11, marginLeft: 'auto' }} />
            </th>
            <th className={styles.colNum}>
              <div className={styles.shimmer} style={{ width: 40, height: 11, marginLeft: 'auto' }} />
            </th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
            <tr key={i} className={styles.bodyRow}>
              <td className={styles.colRank}>
                <div className={styles.shimmer} style={{ width: 20, height: 13 }} />
              </td>
              <td className={styles.colTeam}>
                <div className={styles.shimmer} style={{ width: `${60 + (i % 3) * 20}%`, height: 13 }} />
              </td>
              <td className={styles.colNum}>
                <div className={styles.shimmer} style={{ width: 28, height: 13, marginLeft: 'auto' }} />
              </td>
              <td className={styles.colNum}>
                <div className={styles.shimmer} style={{ width: 28, height: 13, marginLeft: 'auto' }} />
              </td>
              <td className={styles.colNum}>
                <div className={styles.shimmer} style={{ width: 20, height: 13, marginLeft: 'auto' }} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
